module.exports = __webpack_public_path__ + "static/img/home.10d20d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home.png
// module id = KSZv
// module chunks = 1